import React from 'react';
import { connect } from 'react-redux';
import ContactMethodDialog from './ContactMethodDialog';
import WarrantDialog from './WarrantDialog';
import AddAttachment from './AddAttachment';
import EditAttachment from './EditAttachment';
import ReportsDialog from './ReportsDialog';
import DictionaryDialog from './DictionaryDialog';
import RMSPersonTagsDialog from './RMSPersonTagsDialog';
import AddEditPrimaryAddressDialog from './AddEditPrimaryAddressDialog';
import DisplayData from './DisplayData';
import AddWarrantDialog from './AddWarrantDialog';
import EditWarrantDialog from './EditWarrantDialog';
import WarrantPartiesDialog from './EditWarrantDialog/WarrantPartiesDialog';
import AdditionalOffenseDialog from './EditWarrantDialog/AdditionalOffenseDialog';
import BulletinDetails from './BulletinDetails';

function Dialogs(props) {
  const { isAuthenticated, dialogs } = props;
  const {
    addWarrant,
    editWarrant,
    editWarrantParty,
    addPage,
    addOutserviceUnit,
    addEvent,
    editEvent,
    editSop,
    editPageGroup,
    editPageRecipient,
    editPageTemplate,
    dispRecommendation,
    unitProps,
    addNote,
    newUnitStatus,
    unitZone,
    settings,
    displayData,
    sops,
    bulletinDetails,
    report,
    rotations,
    about,
    addUnit,
    editUnit,
    dictionary,
    testing,
    addAttachment,
    editAttachment,
    editContactMethod,
    warrants,
    addEditUnitResource,
    showPersonTagInfo,
    addEditPrimaryAddress,
    addAdditionalOffense,
  } = dialogs;

  return (
    <>
      {isAuthenticated && (
        <>
          {addWarrant !== null && <AddWarrantDialog />}
          {editWarrant !== null && <EditWarrantDialog data={editWarrant} />}
          {editWarrantParty !== null && <WarrantPartiesDialog data={editWarrantParty} />}
          {addAdditionalOffense !== null && <AdditionalOffenseDialog data={addAdditionalOffense} />}

          {editContactMethod !== null && <ContactMethodDialog data={editContactMethod} />}

          {warrants !== null && <WarrantDialog data={warrants} />}

          {addAttachment !== null && <AddAttachment data={addAttachment} />}
          {editAttachment !== null && <EditAttachment data={editAttachment} />}
          {report !== null && <ReportsDialog report={report} />}
          {dictionary !== null && <DictionaryDialog data={dictionary} />}
          {showPersonTagInfo !== null && <RMSPersonTagsDialog data={showPersonTagInfo} />}

          {addEditPrimaryAddress !== null && (
            <AddEditPrimaryAddressDialog data={addEditPrimaryAddress} />
          )}
          {displayData !== null && (
            <DisplayData
              data={displayData.data}
              title={displayData.title}
              ptsAlertID={displayData.ptsAlertID}
            />
          )}
          {bulletinDetails !== null && <BulletinDetails data={bulletinDetails} />}
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.user.isAuthenticated,
    dialogs: state.dialogs,
  };
};

export default connect(mapStateToProps)(Dialogs);
